import { useGetPermissionScopes } from 'hooks/business/useNewPermisson';
import { useCallback } from 'react';

function useGroupValid() {
  const permissionScopes = useGetPermissionScopes()('快捷回复-团队模版');

  const groupValid = useCallback(
    (applyScope?: Phrase.ApplyScocpe) => {
      return storeScopesOverlapWithApplyScope(permissionScopes || [], applyScope);
    },
    [permissionScopes],
  );

  return groupValid;
}

export function storeScopesOverlapWithApplyScope(
  storeScopes: General.StoreScope[],
  applyScope?: Phrase.ApplyScocpe,
) {
  if (!applyScope) {
    return true;
  }

  const {
    scope,
    storesScope: { tunnelTypeRegion = {} } = {},
    tunnelTypeScope: { tunnelTypes = [] } = {},
    tunnelTypeRegionScope: { tunnelTypeRegion: tunnelTypeRegions = {} } = {},
  } = applyScope;

  if (scope === 'ALL') {
    return true;
  }

  return storeScopes.some((platformScope) => {
    const { platform, regionStoreScopes } = platformScope;

    if (tunnelTypes.includes(platform)) {
      return true;
    }

    const isPlatformAll =
      regionStoreScopes.length === 1 &&
      regionStoreScopes[0].region === 'all' &&
      (regionStoreScopes[0].storeIds || []).length === 0;

    const { [platform]: { regions = [] } = {} } = tunnelTypeRegions;

    const { [platform]: { regionStore = {} } = {} } = tunnelTypeRegion;

    if (isPlatformAll && (regions.length || Object.keys(regionStore).length)) {
      return true;
    }

    return regionStoreScopes.some((regionScope) => {
      const { region, storeIds = [] } = regionScope;

      if (region === 'all') {
        return false;
      }

      if (regions.includes(region)) {
        return true;
      }

      const isRegionAll = storeIds.length === 0;

      const { [region]: { storeIds: applyScopeStoreIds = [] } = {} } = regionStore;

      if (isRegionAll && applyScopeStoreIds.length > 0) {
        return true;
      }

      return storeIds.some((id) => applyScopeStoreIds.includes(String(id)));
    });
  });
}

export default useGroupValid;
